export default {
  QUESTION_CREATED: 'create',
  QUESTION_UPDATED: 'question-updated',
  MODERATION_MODE_ENABLED: 'enableModerationMode',
  PRESENTATION_CHANGED: 'presentation-update',
  MODERATION_MODE_CHANGED: 'changeModerationCode',
}
